module.exports = "/_next/static/images/0e45ebab028a640f5ba2903dff7272bd-device-frame-dark@0.5x.png.webp";